import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-OutdoorCitiFormat",
  "use": "svg-icon-OutdoorCitiFormat-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-OutdoorCitiFormat\"><path d=\"M3 0h10v14H9.999L10 16H6v-2H3V0zm2 2v10h6V2H5z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol